import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import Chip from "../ui/Chip";
import { BRAND } from "../../lib/config";
import { Globe, Lock, Zap, ArrowUpRight } from "lucide-react";

export default function WebHostingHero() {
  return (
    <section className="relative overflow-hidden bg-[#070A0F]">
      <div aria-hidden className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(34,211,238,0.16),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_65%,rgba(255,255,255,0.08),transparent_60%)]" />
      </div>

      <Container className="relative z-10">
        <div className="grid my-20 items-center py-12">
          <div className="mx-auto w-full max-w-4xl text-center">
            <div className="mb-7 flex flex-wrap items-center justify-center gap-2">
              <Chip><Zap className="h-4 w-4 text-red-300 mr-3" />WARNING: Web-hosting services are currently unavailable we are working on implementing them within 2026</Chip>
            </div>
            <div className="mb-7 flex flex-wrap items-center justify-center gap-2">
              <Chip><Zap className="h-4 w-4 text-cyan-300 mr-3" /> Fast NVMe</Chip>
              <Chip><Lock className="h-4 w-4 text-cyan-300 mr-3" /> Free SSL</Chip>
              <Chip><Globe className="h-4 w-4 text-cyan-300 mr-3" /> Modern web stack</Chip>
            </div>

            <h1 className="text-balance text-5xl font-semibold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
              Web hosting that feels
              <span className="block">
                simple<span className="text-cyan-300">.</span>
              </span>
            </h1>

            <p className="mx-auto mt-6 max-w-2xl text-pretty text-base leading-7 text-white/70 sm:text-lg">
              Launch fast sites with NVMe storage, automatic backups, and clean support. No upsell maze — just hosting that works.
            </p>

            <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Button href="#plans" className="w-full sm:w-auto">
                View Web Plans <ArrowUpRight className="h-4 w-4 opacity-80" />
              </Button>
              <Button variant="secondary" href={BRAND.supportUrl} className="w-full sm:w-auto">
                Ask Support
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
